import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';



import { GoogleMapScript } from './components/googleMapScript';
import LoginPage from './views/loginPage';
import PagesListPage from './views/pagesListPage';
import AddPagePage from './views/addPagePage';
import ContactListPage from './views/contactListPage';
import ContactPreviewPage from './views/contactPreviewPage';
import SiteDataPage from './views/siteDataPage';
import HomePage from './views/homePage';
import CompetitionListPage from './views/competitionListPage';
import CompetitionPreviewPage from './views/competitionPreviewPage';
import TextPage from './views/textPage';


class Routes extends Component {

    componentDidMount() {

    }

    render() {
        return (
            <Router >
                <div>

                    <GoogleMapScript API_KEY="AIzaSyAAqbIo7N0_Rpwtay3-CWzo5gkfpgWZ4to" />

                    <Switch className="react-switch">
                        <Route
                            path="/"
                            exact
                            render={(...renderProps) => (
                                <HomePage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/login"
                            exact
                            render={(...renderProps) => (
                                <LoginPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/collection/:collection"
                            exact
                            render={(...renderProps) => (
                                <PagesListPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/collection/:collection/:id"
                            exact
                            render={(...renderProps) => (
                                <AddPagePage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/contacts"
                            exact
                            render={(...renderProps) => (
                                <ContactListPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/contacts/:id"
                            exact
                            render={(...renderProps) => (
                                <ContactPreviewPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/competitions"
                            exact
                            render={(...renderProps) => (
                                <CompetitionListPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/competitions/:id"
                            exact
                            render={(...renderProps) => (
                                <CompetitionPreviewPage {...renderProps} {...this.props} />
                            )}
                        />
                        <Route
                            path="/text"
                            exact
                            render={(...renderProps) => (
                                <TextPage {...renderProps} {...this.props} />
                            )}
                        />


                        <Route
                            path="/config"
                            exact
                            render={(...renderProps) => (
                                <SiteDataPage {...renderProps} {...this.props} />
                            )}
                        />
                    </Switch>
                </div>
            </Router >
        );
    }
}

export default Routes;